import { fetchLocalServices } from './apiClients/LocalhostApi';
import { getLocalStorage } from './apiClients/global';
export function shouldUseLocalBackend(detailsObjectIsLocal) {
  const localStorage = getLocalStorage();
  if (detailsObjectIsLocal === true) {
    return true;
  }
  if (detailsObjectIsLocal === false) {
    return false;
  }

  // detailsObjectIsLocal === undefined
  if (localStorage && typeof localStorage.getItem === 'function') {
    // Note: This code requires browser localStorage. It will result in an error in Node.js environments like acceptance tests.
    try {
      const localChirpSetting = localStorage.getItem('LOCAL_CHIRP');
      return localChirpSetting === 'true';
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return false;
    }
  }
  return false;
}
export function shouldForce401() {
  const localStorage = getLocalStorage();
  if (localStorage && typeof localStorage.getItem === 'function') {
    try {
      return localStorage.getItem('CHIRP_FORCE_401') === 'true';
    } catch (error) {
      return false;
    }
  }
  return false;
}
export async function isLocalService(serviceName) {
  try {
    const services = await fetchLocalServices();
    const serviceFound = services.find(service => service.name === serviceName);
    return Boolean(serviceFound);
  } catch (error) {
    console.error('Error fetching local services:', error);
    return false;
  }
}